import objectUtils from '../utils/object-utils'

export default class ProviderAccount {
  constructor (options = {}) {
    this.model = 'ProviderAccount'

    // RouteLeaf attributes
    this.id = objectUtils.get(options, 'id', null)
    this.provider_alias = objectUtils.get(options, 'provider_alias', null)

    // Third-party attributes
    this.thirdparty_id = (options.thirdparty_id) ? options.thirdparty_id.toString() : null
    this.name = objectUtils.get(options, 'name', null)
    this.alias = objectUtils.get(options, 'alias', null)
    this.dba = objectUtils.get(options, 'dba', null)
    this.city = objectUtils.get(options, 'city', null)
    this.description = objectUtils.get(options, 'description', null)
    this.image_src = objectUtils.get(options, 'image_src', null)
    this.banner_src = objectUtils.get(options, 'banner_src', null)
  }
}
